import NextLink from "next/link";
import { Link } from "@chakra-ui/react";
import { ArrowRight } from "@airhelp/icons";
import type { IconLinkProps } from "./IconLink.d";

export const IconLink = ({ icon, text = "", href, prefetch = false, ...props }: IconLinkProps) => (
  <Link
    as={NextLink}
    href={href}
    passHref
    prefetch={prefetch}
    display="inline-flex"
    alignItems="center"
    color="primary.500"
    fontWeight="semibold"
    _hover={{
      textDecor: "none",
    }}
    {...props}
  >
    {text}
    {icon || <ArrowRight mt={0.5} ml={3} />}
  </Link>
);
